export default __webpack_public_path__ + "static/media/Ente-und-Fisch.01ee2528.webp";